module.exports = function(app) {
    app.controller('pages.claims.educationalMaterial', ['$scope', '$location', 'educationalMaterialService', 'storage', 'updateVisited', 'coremetrics','resourcesList','contentResourceServices','$state','session','spendingResourceServices', '$timeout',
        function($scope, $location, educationalMaterialService, storage, updateVisited, coremetrics,resourcesList,contentResourceServices,$state,session,spendingResourceServices, $timeout) {
            $scope.viewState = 'loading';

            $scope.pagination = {
                itemsPerPage: '10'
            };
            $scope.pagination.smallestPage = 10;
            $scope.pagination.page = 1;
            $scope.pagination.items = 0;
            // $scope.pageJSON = function(){
            //     var contentUrl = $location.$$absUrl.replace($location.$$url,"")+"/claims/educational-materials.-1.json/jcr:content";
            //     console.log(contentUrl);
            //     var deferred = $q.defer();
            //     $http.get(contentUrl).then(function(response){
            //         deferred.resolve(response.data);
            //     });
            //     return deferred.promise;
            // };
            // $scope.pageJSON();
            $scope.materials = [];

            $scope.sidebar.keywordOptions={};
            $scope.session = session.data;
            $scope.keywordSearchRefineActive=false;

            $scope.educationalDrawer = false;

            var openFirst = function(){
                var numItems = angular.element('.educationalMaterial').length;
                for (var i=0; i<numItems; i++){
                    var id = angular.element('.educationalMaterial:eq('+ i +') .education-drawer').attr('data-drawer-id');
                    if (!(angular.element('.educationalMaterial:eq('+ i +') .education-drawer').hasClass('ng-hide'))){
                        $scope.open[id] = true;
                        i = numItems;
                    }
                }
            };
            var countItems = function(){
                var numItems = angular.element('.educationalMaterial').length;
                var count = 0;
                for (var i=0; i<numItems; i++){
                    if (!(angular.element('.educationalMaterial:eq('+ i +') .education-drawer').hasClass('ng-hide'))){
                        count++;
                    }
                }
                return count;
            };
            var updatePagination = function(){
                angular.element('.educationalMaterial').hide();
                angular.element('.educationalMaterial > article:not(.ng-hide)').slice($scope.pagination.page * $scope.pagination.itemsPerPage - $scope.pagination.itemsPerPage, $scope.pagination.page * $scope.pagination.itemsPerPage).parent().show();
            };
            $scope.sidebar.refineFilter = '';
            $scope.open = [];
            $scope.$watch('sidebar.refineFilter', function(a,b){
                openFirst();
                $timeout(function() {
                    $scope.materials = new Array(countItems());
                    for (var i=0; i<$scope.materials.length; i++){
                        $scope.materials[i] = i;
                    }
                    $scope.pagination.page = 1;
                    updatePagination();
                }, 250);
            });

            $scope.$watch('pagination.page', function(v) {
                updatePagination();
                storage.set('educationalMaterialPage', v);
            });

            $scope.$watch('pagination.itemsPerPage', function(v) {
                updatePagination();
            });

            if($state.current.name === 'claims.educationalMaterial'){
                $scope.section='memberClaimsEducationalMaterials';
                $scope.isClaims=true;

                $scope.$on('prevClick', function() {
                    var prevPage = $scope.pagination.page;
                    prevPage -= 1;
                    coremetrics.pageviewTag('CLAIMS:CLAIMS AND PAYMENTS ' + prevPage,'MEMBER:CLAIMS');
                    coremetrics.elementTag('PREV:CLAIMS','MEMBER:CLAIMS');
                });

                $scope.$on('nextClick', function() {
                    var nextPage = $scope.pagination.page;
                    nextPage += 1;
                    coremetrics.pageviewTag('CLAIMS:CLAIMS AND PAYMENTS ' + nextPage,'MEMBER:CLAIMS');
                    coremetrics.elementTag('NEXT:CLAIMS','MEMBER:CLAIMS');
                });

                $scope.$on('goToPageClick', function() {
                    coremetrics.elementTag('SELECT PAGE NUMBER:CLAIMS','MEMBER:CLAIMS');
                });
            }else{
                $scope.section='memberSpendingEducationalMaterials';

                $scope.$watch('sidebar.links',function(oldValue,newValue){
                    updateSidebar();
                });
            }

            //$scope.materials = contentResourceServices.resources;

            var updateSidebar=function(){
                $scope.sidebar.links.forEach(function(item){
                    if (item.state === "claims.educationalMaterial" || item.state === "spending.educationalMaterial") {
                        item.refineTemplate = "claims/educational-materials.appTemplate.html/chmhom/pages/claims/educationalMaterialRefine";
                    }
                });
            };

            $scope.$watch("sidebar.keywordRefine.value",function(newValue,oldValue){
                if(newValue!==oldValue){
                    $scope.materials=educationalMaterialService.getFilteredMaterials($scope.sidebar);
                    $scope.keywordSearchRefineActive=true;
                }
            });

            $scope.sidebar.refineOptions=function(){
                $scope.materials=educationalMaterialService.getFilteredMaterials($scope.sidebar);
            };

            $scope.$watch("session.loggedIn", function(){
                $scope.keywordSearchRefineActive=false;
                var getSpendingAccountsPromise=spendingResourceServices.getSpendingAccounts();
                getSpendingAccountsPromise.then(
                    function(spendingAccounts){
                        educationalMaterialService.getFilteredEducationalMaterialV2(resourcesList,$scope.section,true,spendingAccounts).then(function(resources){
                            // $scope.materials = resources;
                            // if($scope.materials[0]){
                            //     $scope.materials[0].isOpen = true;
                            // }

                            $scope.sidebar.keywordOptions=educationalMaterialService.getKeywordRefineOptions($scope.sidebar.keywordOptions);
                            $scope.sidebar.keywordsFilterActive=Object.keys($scope.sidebar.keywordOptions).length > 0;
                            updateSidebar();
                            $scope.viewState='success';
                        });
                    },
                    function(err) {
                        console.error('getSpendingAccounts failed with error', err);
                        $scope.viewState = 'error';
                    }
                );
            });

            $scope.sidebar.clearAll=function(){
                for(var key in $scope.sidebar.keywordOptions){
                    $scope.sidebar.keywordOptions[key]=false;
                }
                if(!$scope.sidebar.keywordRefine || $scope.sidebar.keywordRefine.value === ""){
                    $scope.materials=educationalMaterialService.getFilteredMaterials($scope.sidebar);
                }else{
                    // this will trigger watch function that will update the refine options
                    $scope.sidebar.keywordRefine.value="";
                }
            };

            if($scope.isClaims){
                updateVisited.educationalMaterial();
            }

        }
    ]);
};